import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sControllerEndpoint = 'NegotiationLots';
const sRUControllerEndpoint = 'LotCreationL1';


export class FileManagementAPI {

  uploadFileByLotId(lotId, formData) {
    return axios.post(getBackendURL() + sControllerEndpoint + '/UploadFileByLotId?Id=' + lotId, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  getFilesByLotId(lotId) {
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetFilesByLotId?Id=' + lotId);
  }

  downloadFile(archive, token) {
    let params = {
      archive: archive,
      token: token
    }
    return axios.get(getBackendURL() + sControllerEndpoint + '/DownloadFileById', { params });
  }

  uploadFileByRUL1Id(ruL1Id, formData) {
    return axios.post(getBackendURL() + sRUControllerEndpoint + '/UploadFileByRUL1Id?ruL1Id=' + ruL1Id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  getFilesByRUL1Id(ruL1Id) {
    return axios.get(getBackendURL() + sRUControllerEndpoint + '/GetFilesByRUL1Id?ruL1Id=' + ruL1Id);
  }

  downloadRUFileById(ruArchive, token) {
    let params = {
      ruArchive: ruArchive,
      token: token
    }
    return axios.get(getBackendURL() + sRUControllerEndpoint + '/DownloadRUFileById', { params });
  }

}

export default FileManagementAPI


// WEBPACK FOOTER //
// ./src/API/FileManagementAPI.js